import { ChangeDetectionStrategy, Component, input } from "@angular/core";

import { NotificationType } from "../../../../../../apis/networkdashboard/graphql/graphql";
import { services } from "../../../../../../app/services";
import { AvailabilityExportItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/availability-export/availability-export-item";
import { AvailabilityItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/availability/availability-item";
import { MalfunctionItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/malfunction/malfunction-item";
import { SendConfigItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/send-config/send-config-item";
import { ServiceDocumentationItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/service-documentation/service-documentation";
import { ShortcutMenu } from "../../../../../../components/subscription-detail/shortcut-menu/shortcut-menu";
import { ProductType } from "../../../../../../helpers/enums/productType";
import { L3vpnSubscriptionDetails } from "../../../../../../pages/subscription-detail/types";

@Component({
  selector: "l3vpn-shortcut-menu",
  templateUrl: "l3vpn-shortcut-menu.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MalfunctionItem,
    SendConfigItem,
    AvailabilityItem,
    AvailabilityExportItem,
    ServiceDocumentationItem,
    ShortcutMenu,
  ],
})
export class L3vpnShortCutMenu {
  subscription = input.required<L3vpnSubscriptionDetails>();
  activities = input.required<NotificationType[]>();

  protected readonly serviceDocumentationUrl = services[ProductType.L3VPN].docs;
}
